import { Component, OnInit } from '@angular/core';
import { AlertService } from 'sce-core';
import { ConfirmDialogService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { SearchService } from '../../search/search.service';
import { SearchParams } from '../../search/models/search-params.model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchStatus } from '../../search/models/search-status.model';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { ButtonItem } from '../../button/button.model';
import { SearchEvent } from '../../search/models/search-event';
import { ITEM_CLICK_EVENT, NEW_SEARCH_EVENT } from '../../search/search-constants';
import { Subject } from 'rxjs/Subject';
import { ModalService } from './../../services/modal.service';

@Component({
  selector: 'lfwms-populate-multireceipt-lineitem',
  templateUrl: './populate-multireceipt-lineitem.html',
  styleUrls: ['./populate-multireceipt-lineitem.css']
})
export class PopulateMultiReceiptLineItemComponent implements OnInit {

  public lookupAlertService: AlertService;
  public confirmDialogService: ConfirmDialogService;
  public resourceService: ResourceService;
  public title: string;
  public tabHeaders: Array<string> = ['lbl_default_search', 'lbl_search_by_sku'];
  public currentPage: number = 1;
  public selectedTab: any;
  public tabbedSearchServices: Array<SearchService> = [];
  private populateButton;
  private selectedReceipt: string;
  public receiptDetailService: SearchService;
  private callbackFunction: any;
  private parentRef: any;
  public expandSearchAccordion: boolean = true;
  public eventSubject = new Subject<any>();
  public dataEditor: any;

  constructor(public modalService: ModalService,
      private coreServiceRegistry: CoreServiceRegistry,
      private sharedServiceRegistry: SharedServiceRegistry) {
    this.lookupAlertService = new AlertService();
    this.confirmDialogService = new ConfirmDialogService();
    this.eventSubject = new Subject<any>();
    this.resourceService = this.coreServiceRegistry.resourceService;
    this.populateButton = [
      new ButtonItem('Populate', this.resourceService.get('Populate'), 'vas_wo_popl_masn', 'icon-populate-multi.svg', [])
    ];
  }

  public ngOnInit() {
    this.currentPage = 1;
    // this.selectedTab = '0';
    }

  public registerCallback(callback: any, parentRef: any) {
    this.callbackFunction = callback;
    this.parentRef = parentRef;
  }

  public initializeComponents(dataEditor) {
    this.dataEditor = dataEditor;
    this.initializeSearchServices();
  }

  private initializeSearchServices() {
    if (!this.selectedTab) {
      this.selectedTab = 0;
    }
    this.tabbedSearchServices.push(this.createSearchService('asntd'));
    this.tabbedSearchServices.push(this.createSearchService('searchbyskutd'));
    }

  private createSearchService(tableId: string): SearchService {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    searchParams.defaultSearchColumn = '';
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    searchParams.dataTableConfig = tableConfig;
    searchParams.alertService = this.lookupAlertService;
    searchParams.tableEditor = this.dataEditor;
    if (tableId === 'asntd' || tableId === 'searchbyskutd') {
      searchParams.actionButtons = this.populateButton;
    }
    searchParams.additionalParamMap = { 'docType': 'A' };
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    // JIRA LFWM-1736 Storer/Facility value provided in primary accordion
    // should be a default search condition for Multi ASN Popup
    const defaultSearchCriteria = this.dataEditor.createSearchCriteria();
    searchService.setSearchCriteria(defaultSearchCriteria);
    if (tableId === 'asntd') {
      tableConfig.showIdAsAHyperLink = true;
      searchParams.idProperty = 'receiptKey';
      searchService.receiveEvent().subscribe((event: SearchEvent) => {
        if (event.type === ITEM_CLICK_EVENT) {
          this.selectedReceipt = event.selectedItemId;
          this.fetchLineItemsForSelectedReceipt();
        }
      });
    }

    return searchService;
  }

  private fetchLineItemsForSelectedReceipt() {
    if (!this.receiptDetailService) {
      this.receiptDetailService = this.createSearchService('asndetailtd');
      this.receiptDetailService.receiveEvent().subscribe((searchEvent: SearchEvent) => {
        if (searchEvent.type === NEW_SEARCH_EVENT) {
          this.currentPage = 2;
        }
      });
    } else {
      this.receiptDetailService.clearSearchStatus();
    }
    // Setting Search Criteria in Details Search Service which is the input for Data Table in Details Accordion
    this.receiptDetailService.setSearchCriteria({
      conditions: [{
        mandatory: false,
        clauses: [{
          column: 'receiptKey',
          operation: '=',
          value: this.selectedReceipt,
          logicalOperation: null
        }],
        logicalOperation: null
      }]
    });
    this.receiptDetailService.performSearch();
  }

  public navigateBack() {
    this.currentPage = 1;
  }

  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public onTabChange(tabIndex) {
    this.selectedTab = tabIndex;
  }

  public handleButtonAction(action: string) {
    if (this.callbackFunction && action === 'Populate') {
      const selectedSearchService = this.getSelectedSearchService();
      const noOfLineItems = selectedSearchService.getPagedData().pageDefinition.recordCount;
      const response = {
        type: selectedSearchService.searchParams.tableId,
        selectedRows: selectedSearchService.getSelectedRows()
      };
      if (noOfLineItems === 0) {
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_detail'));
        return;
      }
      this.callbackFunction(this.parentRef, response);
    }
  }

  private getSelectedSearchService(): SearchService {
    let selectedSearchService = null;
    if (this.currentPage === 1) {
      selectedSearchService = (this.selectedTab === 0) ? this.tabbedSearchServices[0] : this.tabbedSearchServices[1];
    } else {
      selectedSearchService = this.receiptDetailService;
    }
    return selectedSearchService;
  }

  public toggleFilterAccordion() {
    this.expandSearchAccordion = !this.expandSearchAccordion;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/populate-multireceipt-lineitem/populate-multireceipt-lineitem.ts